export const TOPICS = [
  { id: "foryou", label: "For You" },
  { id: "nearby", label: "Nearby" },
  { id: "cars", label: "Cars" },
  { id: "music", label: "Music" },
  { id: "food", label: "Food" },
  { id: "sports", label: "Sports" },
  { id: "comedy", label: "Comedy" },
  { id: "night", label: "Night" },
  { id: "cities", label: "Cities" },
] as const

export const INTEREST_TOPICS = TOPICS.filter((item) => item.id !== "foryou" && item.id !== "nearby")

export function parseInterests(value?: string) {
  return (value || "")
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean)
}

export const DAILY_PROMPTS = [
  "10 seconds of your block",
  "Walk from the car to the door",
  "One clip before work",
  "Worst parking lot in town",
  "What’s playing in the speakers",
  "Food that hits after midnight",
  "A car that deserves a slow pan",
]

export const LIBRARY_BEDS = ["Original audio", "Night block", "Trunk bass", "Kitchen radio", "Mute"] as const

export const DRAFT_KEY = "reelhood_create_draft"
export const ONBOARD_KEY = "reelhood_onboarded"
export const CITY_KEY = "reelhood_city"
export const SWAP_HISTORY_KEY = "reelhood_recent_swaps"

export function todayPrompt() {
  const day = Math.floor(Date.now() / 86400000)
  return DAILY_PROMPTS[day % DAILY_PROMPTS.length]
}

export function topicFromCaption(caption: string, fallback = "other") {
  const text = (caption || "").toLowerCase()
  if (/(car|whip|parking|truck|bike)/.test(text)) return "cars"
  if (/(music|song|speaker|bass|beat)/.test(text)) return "music"
  if (/(food|eat|kitchen|grill)/.test(text)) return "food"
  if (/(game|ball|sport)/.test(text)) return "sports"
  if (/(joke|funny|lmao|comedy)/.test(text)) return "comedy"
  if (/(night|late|club|bar)/.test(text)) return "night"
  if (/(city|block|hood|street)/.test(text)) return "cities"
  return fallback
}

export function extractHashtags(caption: string) {
  return (caption.match(/#[A-Za-z0-9_]+/g) || []).join(" ")
}

export function extractMentions(caption: string) {
  return (caption.match(/@[A-Za-z0-9._]+/g) || []).map((item) => item.slice(1).toLowerCase())
}

export function compactCount(value: number) {
  if (value < 1000) return String(value)
  if (value < 10000) return `${(value / 1000).toFixed(1).replace(/\.0$/, "")}k`
  return `${Math.round(value / 1000)}k`
}

export function isBoosted(boostedUntil?: string) {
  if (!boostedUntil) return false
  const at = new Date(boostedUntil).getTime()
  return Number.isFinite(at) && at > Date.now()
}
